<template>
	<div class="left-bar" :class="currentZoom === 100 ? 'colaborators-only' : ''">
		<Description v-if="currentZoom !== 100" class="description" />
		<Microscope class="microscope" />
	</div>
</template>
<style lang="scss" scoped>
	.left-bar {
		box-sizing: border-box;
		width: 100%;
		height: 100%;

		padding-top: 7.875rem;
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		&.colaborators-only {
			justify-content: flex-end;
		}
		.description {
			flex: 1;
		}
		.microscope {
			margin-top: 2.5rem;
		}
	}
</style>
<script>
	import Microscope from "./microscope.vue";
	import Description from "./content-description.vue";
	import { mapState } from "vuex";
	export default {
		components: {
			Microscope,
			Description,
		},
		props: {},
		data() {
			return {};
		},
		computed: {
			...mapState(["currentZoom"]),
		},
	};
</script>
